import React from "react";
import { string } from "prop-types";
import loadable from "@loadable/component";
import { WithLazy } from "@quintype/components";

import IframeWidget from "./iframe";
import { PrayerTimes } from "./PrayerTimes";

import { validURL, widgetsMatch } from "../utils/utils";

const SerialStoriesTab = loadable(() => import("./SerialStoriesTab"));
const TagStorySearch = loadable(() => import("./TagStorySearch"));
const TodaysEvent = loadable(() => import("./TodaysEvent"));

const components = {
  prayertime: PrayerTimes,
  latestnews: SerialStoriesTab,
  localsearch: TagStorySearch,
  todaysevent: TodaysEvent,
  iframe: IframeWidget,
};

export const Widgets = (props) => {
  const { widgetUrl } = props;
  if (!widgetUrl.trim()) return null;

  let widget;

  if (validURL(widgetUrl)) {
    widget = "iframe";
  } else {
    widget = widgetsMatch(widgetUrl, "widget:");
  }

  if (!widget) return null;

  const Widget = components[widget];

  return <WithLazy>{() => <Widget {...props} />}</WithLazy>;
};

Widgets.propTypes = {
  widgetUrl: string,
};
